/** PDF 페이지 너비 (mm, A4 기준) */
export const PDF_PAGE_WIDTH = 210;

/** PDF 페이지 여백 (mm, 상하좌우 동일) */
export const PDF_MARGIN = 5;

/** PDF 테이블 본문 폰트 크기 (pt) */
export const PDF_TABLE_FONT_SIZE = 11;

/** PDF 제목 폰트 크기 (pt) */
export const PDF_TITLE_FONT_SIZE = 16;

/** PDF 부제목(날짜) 폰트 크기 (pt) */
export const PDF_SUBTITLE_FONT_SIZE = 10;

/** PDF 본문 텍스트 색상 (RGB 배열, 회색 계열) */
export const PDF_BODY_TEXT_COLOR = [51, 51, 51] as const;

/** PDF 콘텐츠가 배치될 수 있는 최대 Y 좌표 (mm, A4 높이 297 - 여백) */
export const PDF_MAX_CONTENT_Y = 297 - PDF_MARGIN;

/**
 * 폰트 크기(pt)를 줄 높이(mm)로 변환
 * 동작구조:
 * 1. 1pt ≈ 0.353mm로 변환
 * 2. 1.3배 line-spacing 적용
 * 3. 최소 5mm 보장
 * 파라미터:
 * - fontSize: 폰트 크기 (pt)
 * 예상응답: 줄 높이 (mm)
 */
export const getLineHeight = (fontSize: number) => Math.max(5, fontSize * 0.353 * 1.3);